import { gql } from "@apollo/client"
import { SB_ACCOUNTS_FRAGMENT } from "../../fragments"

const REFRESH_SB_ACCOUNTS_MUTATION = gql`
  ${SB_ACCOUNTS_FRAGMENT}

  mutation($input: RefreshSBAccountsInput!) {
    refreshSBAccounts(input: $input) {
      ...SBAccountFields
    }
  }
`

export { REFRESH_SB_ACCOUNTS_MUTATION }